import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-linkexpire',
  templateUrl: './linkexpire.component.html',
  styleUrls: ['./linkexpire.component.css']
})
export class LinkexpireComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/linkexpire/linkexpire.component.ts